import { useState, useEffect } from "react"
import { Button, Modal, Form } from "react-bootstrap"
import LoadingSpinner from "../Loading/LoadingSpinner"
import { updateAllUserInfo } from "../../firestore/firestore"

export default function UpdateUserModal({ show, onClose, user, onUpdated }) {
  const [formData, setFormData] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        mobile: user.mobile || "",
        address: user.address || "",
        city: user.city || "",
        state: user.state || "",
        zipcode: user.zipcode || "",
        role: user.role || "customer",
      })
    }
  }, [user])

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  async function handleSubmit() {
    const { firstName, lastName, role } = formData
    if (!firstName || !lastName) return alert("First and last name are required.")

    setIsLoading(true)
    try {
      const updatedUser = {
        ...user,
        ...formData,
        fullName: firstName + " " + lastName,
        role,
      }
      await updateAllUserInfo(updatedUser)
      alert(`${updatedUser.fullName} updated successfully.`)
      onUpdated()
      onClose()
    } catch (err) {
      alert("Error updating user: " + err.message)
    } finally {
      setIsLoading(false)
    }
  }

  if (!user) return null

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header className="custom-modal-header" closeButton>
        <Modal.Title>Edit {user.fullName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading && <LoadingSpinner />}
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>First Name</Form.Label>
            <Form.Control type="text" name="firstName" value={formData.firstName || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Last Name</Form.Label>
            <Form.Control type="text" name="lastName" value={formData.lastName || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" name="email" value={formData.email || ""} disabled />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Mobile</Form.Label>
            <Form.Control type="tel" name="mobile" value={formData.mobile || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Address</Form.Label>
            <Form.Control type="text" name="address" value={formData.address || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>City</Form.Label>
            <Form.Control type="text" name="city" value={formData.city || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>State</Form.Label>
            <Form.Control type="text" name="state" value={formData.state || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Zipcode</Form.Label>
            <Form.Control type="text" name="zipcode" value={formData.zipcode || ""} onChange={handleChange} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Role</Form.Label>
            <Form.Select name="role" value={formData.role || ""} onChange={handleChange}>
              <option value="customer">Customer</option>
              <option value="employee">Employee</option>
              <option value="admin">Admin</option>
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit} disabled={isLoading}>Save Changes</Button>
      </Modal.Footer>
    </Modal>
  )
}
